<template>
  <div class="bg-white rounded-sm mx-2 my-3">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-12">
        <LegalDocumentsRegistry/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import LegalDocumentsRegistry from "@/domains/home/services/registry/legal-documents/LegalDocumentsRegistry.vue";
</script>
